import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchUnreadSummary,
  markDisputeCommentsRead,
} from "../../../services/disputeCommentReadsService";

export const fetchUnreadSummaryThunk = createAsyncThunk(
  "disputeCommentReads/fetchSummary",
  async (disputeIds, { rejectWithValue }) => {
    try {
      const ids = (disputeIds || []).filter(Boolean);
      if (ids.length === 0) return [];
      return await fetchUnreadSummary(ids);
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to fetch unread summary");
    }
  }
);

export const markDisputeReadThunk = createAsyncThunk(
  "disputeCommentReads/markRead",
  async (disputeId, { rejectWithValue }) => {
    try {
      const result = await markDisputeCommentsRead(disputeId);
      return { disputeId, ...result };
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to mark dispute read");
    }
  }
);
